import React, { useState } from 'react';
import { IDocument } from '../Interfaces/IDocument';
import {
  Checkbox,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { FindInPage, Link } from '@mui/icons-material';
import { IInvoiceFullObject } from '../Interfaces/IInvoice';
import { DocumentPreviewDialog } from '../Document/DocumentAssistant/DocumentPreviewDialog';

interface IProps {
  invoiceObjects: IInvoiceFullObject[];
  selectedInvoice: number[];
  setSelectedInvoice: Function;
}

export const InvoiceCreateDialogSelect: React.FC<IProps> = ({
  invoiceObjects,
  selectedInvoice,
  setSelectedInvoice,
}) => {
  //

  //
  const [previewObject, setPreviewObject] = useState<IDocument | null>(null);
  const [isOpenPreview, setisOpenPreview] = useState(false);

  const handleOpenPreview = (toPreview: IInvoiceFullObject) => {
    setPreviewObject({
      Created_at: toPreview.Created_at,
      FileName: toPreview.FileName,
      idDocument: -1,
      idDocumentDirectory: -1,
      idLegalTransaction: -1,
      idMIMEType: 1,
      isFromTemplate: false,
      perEmail: false,
      Data: toPreview.Data,
    } as IDocument);
    setisOpenPreview(true);
  };

  return (
    <>
      <DocumentPreviewDialog
        open={isOpenPreview}
        localDocumentObject={previewObject}
        onClose={() => setisOpenPreview(false)}
      />

      <Typography>
        Bitte wählen Sie die zu erstellenden Rechnungen aus
      </Typography>
      <Table size='small'>
        <TableHead>
          <TableCell></TableCell>
          <TableCell>Vorgang</TableCell>
          <TableCell>Rechnungsnummer</TableCell>
          <TableCell>Summe</TableCell>
          <TableCell>Aktionen</TableCell>
        </TableHead>
        <TableBody>
          {invoiceObjects.map(inv => (
            <TableRow>
              <TableCell>
                <Checkbox
                  size='small'
                  checked={selectedInvoice.includes(inv.idInvoice)}
                  disabled={inv.idLegalTransaction < 0}
                  onChange={() =>
                    selectedInvoice.includes(inv.idInvoice)
                      ? setSelectedInvoice([
                          ...selectedInvoice.filter(
                            sel => sel !== inv.idInvoice
                          ),
                        ])
                      : setSelectedInvoice([...selectedInvoice, inv.idInvoice])
                  }
                />
              </TableCell>
              <TableCell colSpan={inv.idLegalTransaction > 0 ? undefined : 2}>
                {inv.idLegalTransaction > 0 ? (
                  <>
                    {inv.Title}
                    <IconButton
                      onClick={() =>
                        window.open(
                          `legaltransaction/${inv.idLegalTransaction}`,
                          '_blank'
                        )
                      }
                      size='small'
                    >
                      <Link />
                    </IconButton>
                  </>
                ) : (
                  <>Konnte kein Vorgang bestimmen</>
                )}
              </TableCell>
              {inv.idLegalTransaction > 0 && (
                <TableCell>{inv.InvoiceNumber}</TableCell>
              )}
              <TableCell>
                {inv.Total?.toLocaleString('de-DE', {
                  style: 'currency',
                  currency: 'EUR',
                })}
              </TableCell>
              <TableCell>
                <IconButton onClick={() => handleOpenPreview(inv)}>
                  <FindInPage />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </>
  );
};
